module.exports = __webpack_public_path__ + "static/logo_farbvision-93bcd467c2c7631dcea7dfe0bcf89bde.svg";